"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSidebarComponent = void 0;
const constants = require("../../../util/constants");
class CSSidebarComponent {
    constructor() {
    }
    /**
     * @retuns redirects the user to sign in page
     */
    goToSignIn() {
        location.href = constants.loginUrl;
    }
    /**
     * @retuns redirects the user to registration page
     */
    goToRegister() {
        location.href = '/mycspirebusiness/registration/';
    }
}
exports.CSSidebarComponent = CSSidebarComponent;
//# sourceMappingURL=order-status-sidebar.component.js.map